/*
 *@providesModule GDPRCheckboxStyles
 *
 */

import Sizes from 'Sizes';
import SkillzStyle from 'SkillzStyle';
import {
  StyleSheet
} from 'react-native';

const {
  fontPrimary,
  fontSizeH5,
  fontSizeH4,
  textColorPrimary,
  viewCornerRadiusPrimary,
  backgroundViewGradient,
} = SkillzStyle.fullStyles;

export default StyleSheet.create({

  mainContainer: {
    ...viewCornerRadiusPrimary,
    flexDirection: 'row',
    alignSelf: 'stretch',
    maxWidth: '100%',
    height: 45,
    //TODO: determine what background color is actually supposed to be
    backgroundColor: backgroundViewGradient[1],
  },

  checkboxContainer: {
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
  },

  checkBox: {
    height: 25,
    width: 25,
  },

  checkBoxFill: {
    ...viewCornerRadiusPrimary,
    position: 'absolute',
    top: 1,
    left: 1,
    right: 1,
    bottom: 1,
  },

  checkmark: {
    height: 15,
    width: 15,
    position: 'absolute'
  },

  textContainer: {
    flex: 1,
    height: '100%',
    justifyContent: 'center',
  },

  textStyle: {
    ...textColorPrimary,
    ...fontPrimary,
    ...Sizes.select({
      tablet: {
        ...fontSizeH4,
      },
      phone: {
        ...fontSizeH5,
      },
    }),
  },
});
